// В.1.c-1: линейно-триггерные keyword'ы Глобала.
//
// «При нахождении на N-й линии получает <keyword>» — это динамический
// keyword, который появляется и исчезает при изменении линии юнита,
// при наложении Молчания, при смерти. State Resolver пересобирает
// derivedKeywords каждого юнита и синхронизирует card.keywords с учётом
// других источников (base, Mods, persistentKeywords от Стимулятора).
//
// Регистрация:
//   LINE_KEYWORD_TRIGGERS[card.id] = { line: 0|1, kw: 'pierce'|'taunt'|'frenzy' }
//   line: 0 — 1-я линия, 1 — 2-я линия (как в card.line).
//
// Источники keyword'а на юните (учитываются при удалении derived):
//   - card.template.keywords (immutable база из xlsx)
//   - card.modifications[*].applied.keywordsAdded (Моды Синтетика)
//   - card.persistentKeywords (Кустарный стимулятор и т.п.)
//
// Если другой источник keyword всё ещё держит его, derived-удаление НЕ
// снимает kw из card.keywords — только из derivedKeywords.

import { hasKeyword, removeKeyword, KW } from '../keywords.js';

const LINE_KEYWORD_TRIGGERS = {
  glb_snayper_s_tyazheloy_vintovkoy: { line: 1, kw: KW.PIERCE },
  glb_meh_prikrytiya_pehoty:         { line: 1, kw: KW.TAUNT  },
  glb_raschet_tyazhelogo_pulemeta:   { line: 0, kw: KW.FRENZY }
};

// Желаемый набор derived-keyword'ов для конкретной карты.
function desiredFor(card) {
  const out = new Set();
  if (!card || !card.isAlive || !card.isAlive()) return out;
  if (card.current && card.current.silenced) return out;          // Молчание — никаких триггеров
  const trig = LINE_KEYWORD_TRIGGERS[card.id];
  if (!trig) return out;
  if (card.line !== trig.line) return out;
  out.add(trig.kw);
  return out;
}

// Проверка: даёт ли keyword кто-то ещё, кроме нашего derived.
function hasKwFromOtherSources(card, kw) {
  if (Array.isArray(card.template?.keywords) && card.template.keywords.includes(kw)) return true;
  if (Array.isArray(card.persistentKeywords) && card.persistentKeywords.includes(kw)) return true;
  for (const m of (card.modifications || [])) {
    if (Array.isArray(m.applied?.keywordsAdded) && m.applied.keywordsAdded.includes(kw)) return true;
  }
  return false;
}

function addDerived(card, kw) {
  if (!Array.isArray(card.derivedKeywords)) card.derivedKeywords = [];
  if (!card.derivedKeywords.includes(kw)) card.derivedKeywords.push(kw);
  if (!hasKeyword(card, kw)) card.keywords.push(kw);
}

function removeDerived(card, kw) {
  if (Array.isArray(card.derivedKeywords)) {
    card.derivedKeywords = card.derivedKeywords.filter(x => x !== kw);
  }
  // Снимать из card.keywords только если ни один другой источник не даёт.
  if (!hasKwFromOtherSources(card, kw)) {
    removeKeyword(card, kw);
  }
}

// Применить дельту: пересинхронизировать derivedKeywords и card.keywords с desired.
function applyForCard(card) {
  const desired = desiredFor(card);
  const current = new Set(card.derivedKeywords || []);
  for (const kw of current) {
    if (!desired.has(kw)) removeDerived(card, kw);
  }
  for (const kw of desired) {
    if (!current.has(kw)) addDerived(card, kw);
  }
}

// Полный пересчёт по всему полю.
export function recomputeLineTriggers(state) {
  if (!state || !state.players) return;
  for (let pi = 0; pi < 2; pi++) {
    const p = state.players[pi];
    if (!p) continue;
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        const u = p.field[line][slot];
        if (!u) continue;
        applyForCard(u);
      }
    }
  }
}

// Полный сброс derived-keyword'ов с одной карты (например при смерти/уходе с поля).
// Нужен для чистоты State Resolver — иначе derivedKeywords остаются на трупе.
export function clearDerivedKeywordsFor(card) {
  if (!card || !Array.isArray(card.derivedKeywords)) return;
  for (const kw of [...card.derivedKeywords]) {
    removeDerived(card, kw);
  }
}
